"use client";

import { withFallback } from "../with-fallback";

export const SearchElement = withFallback({
	displayName: "SearchElement",
	type: "search-element",
} as const);
